import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App.tsx";
import "./index.css";
import { ThemeProvider } from "./components/theme-provider.tsx";
import { ClerkThemeProvider } from "./components/clerk-theme-provider.tsx";
import { QueryProvider } from "./providers/QueryProvider.tsx";

// Import your Publishable Key
const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

// Get the base path from Vite config
const basePath = import.meta.env.BASE_URL || "/app/";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryProvider>
      <ThemeProvider defaultTheme="light" storageKey="forge-ui-theme">
        <ClerkThemeProvider
          publishableKey={PUBLISHABLE_KEY!}
          signInFallbackRedirectUrl={basePath}
          afterSignOutUrl={basePath}
          signUpFallbackRedirectUrl={basePath}
        >
          <Router basename="/app">
            <App />
          </Router>
        </ClerkThemeProvider>
      </ThemeProvider>
    </QueryProvider>
  </React.StrictMode>,
);
